import { Route, createPageRoute, AppId } from '@lumapps/router';

export const surveyViewRoute: Route = createPageRoute({
    slug: 'surveys/:id',
    appId: AppId.frontOffice,
});

export const prefillSurveyRoute: Route = createPageRoute({
    slug: 'surveys/:id/prefill',
    appId: AppId.frontOffice,
});

export const surveySubmissionViewRoute: Route = createPageRoute({
    slug: 'surveys/:id/submissions/:submissionId',
    appId: AppId.frontOffice,
});
